import { Routes } from '@angular/router';

export const classesRoutes: Routes = [
  {
    path: 'classes',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/class-list/class-list.component').then(
            (m) => m.ClassListComponent
          ),
      },
      {
        path: ':classId',
        loadComponent: () =>
          import('./components/class-detail/class-detail.component').then(
            (m) => m.ClassDetailComponent
          ),
        children: [
          {
            path: '',
            redirectTo: 'announcements',
            pathMatch: 'full',
          },
          {
            path: 'announcements',
            loadComponent: () =>
              import('./components/class-announcements/class-announcements.component').then(
                (m) => m.ClassAnnouncementsComponent
              ),
          },
          {
            path: 'students',
            loadComponent: () =>
              import('./components/class-students/class-students.component').then(
                (m) => m.ClassStudentsComponent
              ),
          },
          {
            path: 'planner',
            loadComponent: () =>
              import('./components/class-planner/class-planner.component').then(
                (m) => m.ClassPlannerComponent
              ),
          },
          {
            path: 'resources',
            loadComponent: () =>
              import('./components/class-resources/class-resources.component').then(
                (m) => m.ClassResourcesComponent
              ),
          },
        ],
      },
    ],
  },
];
